import { Caption } from '@depop/web-thrift-ui/Typography';
import { useTranslations } from 'next-intl';

import { ExtendedLink } from '../ExtendedLink';

import styles from './styles.module.css';

import { type FooterLink } from '@/modules/footer/types';

export function FooterLinkItem({ link }: { link: FooterLink }) {
  const t = useTranslations('common');
  const { text, linkAddress, asAnchor } = link;
  const Wrapper = asAnchor ? 'a' : ExtendedLink;

  return (
    <div className={styles.footerLinkWrapper}>
      <Wrapper className={styles.footerLink} href={linkAddress}>
        <Caption variant="lg-regular" colour="base">
          {t(text) || text}
        </Caption>
      </Wrapper>
    </div>
  );
}
